import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import classNames from 'classnames';

import css from './Breadcrumbs.module.css';

const Breadcrumbs = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <nav className={classes}>
      <ul className={css.breadcrumbList}>
        <li className={css.breadcrumbItem}>
          <NamedLink className={css.breadcrumbLink} name="SearchUsersPage">
            <FormattedMessage id="SearchUsersPage.MainPanelHeader.Breadcrumbs.home" />
          </NamedLink>
        </li>
        <li className={css.breadcrumbItem}>
          <NamedLink className={css.breadcrumbLink} name="SearchUsersPage">
            <FormattedMessage id="SearchUsersPage.MainPanelHeader.Breadcrumbs.sellers" />
          </NamedLink>
        </li>
      </ul>
    </nav>
  );
};

Breadcrumbs.defaultProps = {
  rootClassName: null,
  className: null,
};

Breadcrumbs.propTypes = {
  rootClassName: string,
  className: string,
};

export default Breadcrumbs;
